export default "__VITE_ASSET__BK7QZH$B__"